import { type IEmbedSpotify } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function Spotify ({ id }: IEmbedSpotify) {
  return (
    <iframe
      className={['spotify-embed', styles.spotifyEmbed].join(' ')}
      height='152'
      loading='lazy'
      src={`${id}?utm_source=generator`}
      width='100%'
    />
  );
}
